<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    console.log('app mounted')
  }
}
</script>

<style lang="scss">
@import 'style/base';

#app {
  min-width: 1366px;
  font-size: 14px;
  color: #333;
}
</style>
